// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__38b2C","item":"PaymentsMobile_item__2__Qi","label":"PaymentsMobile_label__2cnkg","amount":"PaymentsMobile_amount__IbHcU"};